// cspell:ignore linehaul uccc

import type { ServiceFailureRecapReportResponse } from "../../hooks/react-query/linehaul/useServiceFailureRecapReport";

/** Wire-format JSON for GET uc-cc-ofd/service-failure-recap (MSW). */
export const mockServiceFailureRecapReport = {
  serviceStartDate: "2026-02-01",
  serviceEndDate: "2026-02-28",
  totalUcCount: 3,
  totalCcCount: 2,
  totalServiceFailures: 5,
  onTimePerformance: {
    percentage: 88.5,
    onTimeCount: 177,
    total: 200,
  },
  shipments: [
    {
      shipmentId: 1001,
      proNumber: "001234567",
      pickupDateUtc: "2026-02-01T08:00:00.000Z",
      originSic: {
        id: 101,
        code: "LAX",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 202,
        code: "BOS",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/New_York",
      },
      shipper: {
        id: 1,
        name: "ABC Logistics",
        address: "100 Industrial Pkwy",
        city: "Los Angeles",
        state: "CA",
        zipCode: "90001",
      },
      consignee: {
        id: 2,
        name: "CAPE MARINE INC",
        address: "200 Harbor Way",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      shipmentTags: ["UC"],
      fbStatus: "ENRT",
      billToParty: {
        id: 1,
        name: "ABC Logistics",
        address: "100 Industrial Pkwy",
        city: "Los Angeles",
        state: "CA",
        zipCode: "90001",
      },
      salesRep: "John Smith",
      invoice: 536.68,
      failureReason: "Daylight Failure",
      subReason: "Late OB Close",
      explanation:
        "Origin ATL SIC cut the load out late versus committed window.",
    },
    {
      shipmentId: 1002,
      proNumber: "001235789",
      pickupDateUtc: "2026-02-03T14:00:00.000Z",
      originSic: {
        id: 102,
        code: "ORD",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 203,
        code: "ATL",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/New_York",
      },
      shipper: {
        id: 3,
        name: "Fast Freight Inc",
        address: "100 Industrial Pkwy",
        city: "Chicago",
        state: "IL",
        zipCode: "60601",
      },
      consignee: {
        id: 2,
        name: "CAPE MARINE INC",
        address: "200 Harbor Way",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      shipmentTags: ["CC"],
      fbStatus: "ENRT",
      billToParty: {
        id: 3,
        name: "Fast Freight Inc",
        address: "100 Industrial Pkwy",
        city: "Chicago",
        state: "IL",
        zipCode: "60601",
      },
      salesRep: "Sarah Johnson",
      invoice: 824.5,
      failureReason: "Daylight Failure",
      subReason: "Late OB Close",
      explanation:
        "Origin ATL SIC cut the load out late versus committed window.",
    },
    {
      shipmentId: 1003,
      proNumber: "001236890",
      pickupDateUtc: "2026-02-05T14:00:00.000Z",
      originSic: {
        id: 103,
        code: "DFW",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/Chicago",
      },
      destinationSic: {
        id: 204,
        code: "MIA",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/New_York",
      },
      shipper: {
        id: 4,
        name: "Coastal Shipping",
        address: "100 Industrial Pkwy",
        city: "Dallas",
        state: "TX",
        zipCode: "75201",
      },
      consignee: {
        id: 2,
        name: "CAPE MARINE INC",
        address: "200 Harbor Way",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      shipmentTags: ["UC"],
      fbStatus: "ENRT",
      billToParty: {
        id: 4,
        name: "Coastal Shipping",
        address: "100 Industrial Pkwy",
        city: "Dallas",
        state: "TX",
        zipCode: "75201",
      },
      salesRep: "Mike Davis",
      invoice: 1247.89,
      failureReason: "Daylight Failure",
      subReason: "Late OB Close",
      explanation:
        "Origin ATL SIC cut the load out late versus committed window.",
    },
    {
      shipmentId: 1004,
      proNumber: "001237901",
      pickupDateUtc: "2026-02-07T08:00:00.000Z",
      originSic: {
        id: 104,
        code: "SEA",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/Los_Angeles",
      },
      destinationSic: {
        id: 205,
        code: "DEN",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/Denver",
      },
      shipper: {
        id: 5,
        name: "Mountain Transport",
        address: "100 Industrial Pkwy",
        city: "Seattle",
        state: "WA",
        zipCode: "98101",
      },
      consignee: {
        id: 2,
        name: "CAPE MARINE INC",
        address: "200 Harbor Way",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      shipmentTags: ["CC", "UC"],
      fbStatus: "ENRT",
      billToParty: {
        id: 5,
        name: "Mountain Transport",
        address: "100 Industrial Pkwy",
        city: "Seattle",
        state: "WA",
        zipCode: "98101",
      },
      salesRep: "Lisa Brown",
      invoice: 675.23,
      failureReason: "Daylight Failure",
      subReason: "Late OB Close",
      explanation:
        "Origin ATL SIC cut the load out late versus committed window.",
    },
    {
      shipmentId: 1005,
      proNumber: "001238012",
      pickupDateUtc: "2026-02-10T05:00:00.000Z",
      originSic: {
        id: 105,
        code: "BOS",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/New_York",
      },
      destinationSic: {
        id: 206,
        code: "PHX",
        ownership: "Linehaul",
        lhRegionId: 10,
        timeZone: "America/Phoenix",
      },
      shipper: {
        id: 6,
        name: "Northeast Cargo",
        address: "100 Industrial Pkwy",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      consignee: {
        id: 2,
        name: "CAPE MARINE INC",
        address: "200 Harbor Way",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      shipmentTags: ["UC"],
      fbStatus: "ENRT",
      billToParty: {
        id: 6,
        name: "Northeast Cargo",
        address: "100 Industrial Pkwy",
        city: "Boston",
        state: "MA",
        zipCode: "02110",
      },
      salesRep: "Tom Wilson",
      invoice: 952.41,
      failureReason: "Daylight Failure",
      subReason: "Late OB Close",
      explanation:
        "Origin ATL SIC cut the load out late versus committed window.",
    },
  ],
  monthlySummaries: [
    {
      title: "January 2026 UC/CC Totals",
      year: 2026,
      month: 1,
      days: [
        {
          serviceDate: "2026-01-02",
          deliveryDueDateLabel: "MON 1/2",
          urgentCareCount: 12,
          criticalCareCount: 8,
          totalFailures: 2,
          ucCcTotal: 20,
          totalShipments: 22,
          onTimePercentage: 90.0,
        },
        {
          serviceDate: "2026-01-03",
          deliveryDueDateLabel: "TUE 1/3",
          urgentCareCount: 15,
          criticalCareCount: 10,
          totalFailures: 1,
          ucCcTotal: 25,
          totalShipments: 26,
          onTimePercentage: 96.0,
        },
        {
          serviceDate: "2026-01-04",
          deliveryDueDateLabel: "WED 1/4",
          urgentCareCount: 18,
          criticalCareCount: 12,
          totalFailures: 3,
          ucCcTotal: 30,
          totalShipments: 33,
          onTimePercentage: 90.0,
        },
        {
          serviceDate: "2026-01-05",
          deliveryDueDateLabel: "THU 1/5",
          urgentCareCount: 14,
          criticalCareCount: 9,
          totalFailures: 2,
          ucCcTotal: 23,
          totalShipments: 25,
          onTimePercentage: 15.3,
        },
        {
          serviceDate: "2026-01-06",
          deliveryDueDateLabel: "FRI 1/6",
          urgentCareCount: 20,
          criticalCareCount: 15,
          totalFailures: 4,
          ucCcTotal: 35,
          totalShipments: 39,
          onTimePercentage: 88.57,
        },
        {
          serviceDate: "2026-01-09",
          deliveryDueDateLabel: "MON 1/9",
          urgentCareCount: 16,
          criticalCareCount: 11,
          totalFailures: 1,
          ucCcTotal: 27,
          totalShipments: 28,
          onTimePercentage: 96.3,
        },
        {
          serviceDate: "2026-01-10",
          deliveryDueDateLabel: "TUE 1/10",
          urgentCareCount: 13,
          criticalCareCount: 8,
          totalFailures: 0,
          ucCcTotal: 21,
          totalShipments: 21,
          onTimePercentage: 100.0,
        },
      ],
      mtdTotals: {
        rowLabel: "MTD",
        totalUrgentCare: 108,
        totalCriticalCare: 73,
        totalFailures: 13,
        totalUcCc: 181,
        overallOnTimePercentage: 82.4,
      },
    },
  ],
  rangeTotals: {
    rowLabel: "Selected range",
    totalUrgentCare: 108,
    totalCriticalCare: 73,
    totalFailures: 13,
    totalUcCc: 181,
    overallOnTimePercentage: 88.5,
  },
} as const satisfies ServiceFailureRecapReportResponse;
